import CandidateDetails from './CandidateDetails';
export default CandidateDetails
